import React from 'react';
import { connect } from "react-redux";
import ControlService from "../../helper/controlservice";
import PropTypes from 'prop-types';
import * as formsAction from "../../redux/actions/formsAction";
import * as Actions from "../../redux/actions/loginAction";
import Loading from '../../helper/component/Loading';
// import ErrorBoundary from '../../helper/component/ErrorBoundary';
// const DynamicForm = React.lazy(() => import("../DynamicForm"));
import DynamicForm from '../DynamicForm';

function bindAction(dispatch) {
  return {
    resetData: (data, storekey) => dispatch(formsAction.resetFormData(data, storekey)),
    resetFilter: (data) => dispatch(formsAction.resetFilterData(data)),
    setSidebarFormName: (formname) => dispatch(formsAction.setSidebarFormName(formname)),
    setModelFormName: (formname) => dispatch(formsAction.setModelFormName(formname)),
    dataIsLoading: (bool) => dispatch(formsAction.dataIsLoading(bool)),
    setreload: (bool) => dispatch(formsAction.setreload(bool)),
    resetRealTimeSync: (bool) => dispatch(formsAction.resetRealTimeSync(bool)),
    authSetToken: (data) => dispatch(Actions.authSetToken(data)),
  };
}
const mapStateToProps = state => ({
  data: state.formDataReducer,
  pageparams: state.formDataReducer.pageparams,
  token: state.formLoginReducer.token,
  hasErrored: state.formDataReducer.hasErrored,
  isLoading: state.formDataReducer.isLoading,
  reload: state.formDataReducer.reload,
  realtimeSync: state.formDataReducer.realtimeSync,
  isSidebarOpened: state.formDataReducer.isSidebarOpened,
  isModelOpened: state.formDataReducer.isModelOpened,
  sidebarFormName: state.formDataReducer.sidebarFormName,
  modelFormName: state.formDataReducer.modelFormName,
});
class DynamicformInit extends React.PureComponent {
  constructor() {
    super();

    this.state = {
      formUI: null,
      isApiCalling: false,
      showheader: true,
      HeaderTitle: null,
      refreshPage: false
    }
  }
  static getDerivedStateFromProps(nextProps) {
    return {
      refreshPage: nextProps.reload
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (typeof this.state.refreshPage == 'object' && this.state.refreshPage.refresh == true && this.state.formUI && this.props.access !== "filter") {
      if (this.state.refreshPage.formid === 'page' || this.state.refreshPage.formid === this.state.formUI.Id) {
        this.props.setreload(false);
        var datamodel = this.state.formUI.ModelJson;
        ControlService().GenerateDataJson(this.state.formUI.controls ? this.state.formUI.controls : [], datamodel, null, true);
        this.loadModelJson(this.state.formUI, this.props.access);
      }
    }
  }
  componentDidMount() {
    debugger;
    if (this.props.formtype == 'sidebar' && this.props.sidebarFormName) {
      this.props.setSidebarFormName("");
    }
    if (this.props.formtype == 'model' && this.props.modelFormName) {
      this.props.setModelFormName("");
    }

    this.loadFormUI(this.props.formid);
    if (this.props.realtimeSync) {
      this.props.resetRealTimeSync(false);
    }
  }
  loadFormUI(formid) {
    const { token } = this.props;
    if (formid && token) {
      this.setState({
        formUI: null,
        isApiCalling: true
      })
      if (this.props.landingPage) {
        this.props.dataIsLoading(true);
      }

      ControlService().loadMetadata(formid, token)
        .then(response => {
          debugger;
          if (this.props.formtype == 'sidebar') {
            this.props.setSidebarFormName(response.Formname);
          }
          if (this.props.formtype == 'model') {
            this.props.setModelFormName(response.Formname);
          }
          if (this.props.access === 'filter') {
            this.props.resetFilter(response.FilterModelJson);
          }
          if (this.props.datamodel) {
            let datamodel = this.props.datamodel;
            ControlService().GenerateDataJson(response.controls ? response.controls : [], datamodel);
            this.props.resetData(datamodel, formid + this.props.access);
            this.getTitle(datamodel, response.Formname);

            this.setState({
              formUI: response,
              isApiCalling: false
            })
            if (this.props.landingPage) {
              this.props.dataIsLoading(false);
            }
          } else {
            this.setState({
              formUI: response,
            })
            this.loadModelJson(response)
          }
        })
        .catch((e) => {
          if (this.props.formtype == 'sidebar') {
            this.props.setSidebarFormName("");
          }
          if (this.props.formtype == 'model') {
            this.props.setModelFormName("");
          }
          this.setState({
            isApiCalling: false
          })
          if (this.props.landingPage) {
            this.props.dataIsLoading(false);
          }
        })
    } else if (this.props.formui) {
      this.setState({
        isApiCalling: true
      })
      if (this.props.landingPage) {
        this.props.dataIsLoading(true);
      }

      this.setState({
        formUI: this.props.formui
      })
      if (this.props.formtype == 'sidebar') {
        this.props.setSidebarFormName(this.props.formui.Formname);
      }
      if (this.props.formtype == 'model') {
        this.props.setModelFormName(this.props.formui.Formname);
      }

      if (this.props.datamodel) {
        let datamodel = this.props.datamodel;
        ControlService().GenerateDataJson(this.props.formui.controls ? this.props.formui.controls : [], datamodel);
        this.props.resetData(datamodel, this.props.formui.Id + this.props.access);
        this.getTitle(datamodel, this.props.formui.Id);
        this.setState({
          isApiCalling: false
        })
        if (this.props.landingPage) {
          this.props.dataIsLoading(false);
        }
      } else {
        this.loadModelJson(this.props.formui);
      }
    }
  }
  loadModelJson(formUI) {
    const { token } = this.props;
    if (this.props.access != 'filter' && ((formUI.getdatasource && formUI.getconnection) || formUI.GetEndpoint) && this.props.pageparams != "AddNew") {
      this.setState({
        isApiCalling: true
      });
      var apiparam = {}
      formUI.GetEndpointParams.forEach(option => {
        apiparam[option.key] = option.value;
      });
      var control = {
        datasource: formUI.getdatasource,
        method: formUI.getmethod,
        headers: formUI.getheaders,
        connection: formUI.getconnection,
        model: formUI.getmodel,
        query: formUI.getquery,
        ResultApiParam: formUI.GetEndpointParams,
        realtime: formUI.realtime,
        payload: formUI.payload,
        sprocname: formUI.getsprocname
      }
      ControlService().ServiceRequest(formUI.GetEndpoint, apiparam, control, token, this.props.pageparams, null, null, this.setApiResultFromCallback.bind(this), this.props)
        .then(data => {
          if (this.props.landingPage) {
            this.props.dataIsLoading(false);
          }
          let datamodel = {}
          if (formUI.getresponsefield) {
            datamodel = data[formUI.getresponsefield] ? data[formUI.getresponsefield] : {};
            if (Array.isArray(datamodel)) {
              datamodel = datamodel.length > 0 ? datamodel[0] : {};
            }
          } else if (Array.isArray(data)) {
            datamodel = data.length > 0 ? data[0] : {};
          }
          else if (typeof data == 'object')
            datamodel = data;
          else {
            datamodel = { '': data };
          }

          // var datamodel = Array.isArray(res) && res.length > 0 ? res[0] : res;
          ControlService().GenerateDataJson(formUI.controls ? formUI.controls : [], datamodel);
          this.props.resetData(datamodel, formUI.Id + this.props.access);
          this.getTitle(datamodel, formUI.Formname);
          this.setState({
            isApiCalling: false
          });
        })
        .catch(() => {

          if (this.props.landingPage) {
            this.props.dataIsLoading(false);
          }
          let datamodel = formUI.ModelJson;
          ControlService().GenerateDataJson(formUI.controls ? formUI.controls : [], datamodel);
          this.props.resetData(datamodel, formUI.Id + this.props.access);
          this.getTitle(datamodel, formUI.Formname);
          this.setState({
            isApiCalling: false
          });
        });
    } else {
      if (this.props.landingPage) {
        this.props.dataIsLoading(false);
      }
      if (this.props.pageparams && typeof this.props.pageparams == "object" && this.props.pageparams.type == 'model') {
        let datamodel = this.props.pageparams.data;
        ControlService().GenerateDataJson(formUI.controls ? formUI.controls : [], datamodel, null, true);
        this.props.resetData(datamodel, formUI.Id + this.props.access);
        this.getTitle(datamodel, formUI.Formname);
      } else {
        let datamodel = formUI.ModelJson;
        ControlService().GenerateDataJson(formUI.controls ? formUI.controls : [], datamodel, null, true);
        this.props.resetData(datamodel, formUI.Id + this.props.access);
        this.getTitle(datamodel, formUI.Formname);
      }
      this.setState({
        isApiCalling: false
      });
    }
  }
  setApiResultFromCallback(data) {
    let datamodel = {}
    if (Array.isArray(data))
      datamodel = data.length > 0 ? data[0] : {};
    else if (typeof data == 'object')
      datamodel = data;
    else {
      datamodel = { '': data };
    }

    // var datamodel = Array.isArray(res) && res.length > 0 ? res[0] : res;
    ControlService().GenerateDataJson(this.state.formUI.controls ? this.state.formUI.controls : [], datamodel);
    this.props.resetData(datamodel, this.state.formUI.Id + this.props.access);
  }
  getTitle(data, Formname) {
    var { token } = this.props;
    debugger;
    let menu = token.menu ? token.menu : {};
    let applicationtitlepage = menu.applicationtitle
    if (this.props.token && this.props.content) {
      if (data && this.props.content && this.props.content.DynamicTitle) {
        if (menu.applicationtitlefrompage) {
          if (applicationtitlepage && applicationtitlepage.indexOf('{{}}') > -1) {
            applicationtitlepage = applicationtitlepage.replace('{{}}', data[this.props.content.DynamicTitle])
          } else {
            applicationtitlepage = data[this.props.content.DynamicTitle];
          }
          token.menu = menu;
          this.props.authSetToken(token);
        } else {
          this.setState({ HeaderTitle: data[this.props.content.DynamicTitle] });
        }
      } else if (this.props.content) {
        if (menu.applicationtitlefrompage) {
          if (applicationtitlepage && applicationtitlepage.indexOf('{{}}') > -1) {
            applicationtitlepage = applicationtitlepage.replace('{{}}', this.props.content.Title)
          } else {
            applicationtitlepage = this.props.content.Title;
          }
          menu.applicationtitlepage = applicationtitlepage;
          token.menu = menu;
          this.props.authSetToken(token);
        } else {
          this.setState({ HeaderTitle: this.props.content.Title });
        }
      }
    }
  }
  render() {
    const { isApiCalling } = this.state;
    const { token } = this.props;
    if (isApiCalling && !this.props.landingPage) {
      return (
        <Loading token={this.props.token} enable={isApiCalling} />
      )
    }
    else
      if (!isApiCalling && this.state.formUI && token && this.props.landingPage) {
        return (
          this.state.HeaderTitle ?
            <div style={{ backgroundColor: this.props.content.panelbg }} className={"card mb-2 " + (this.props.content.showshadow && 'shadow') + ' ' + (this.props.content.panelClass) + ' ' + (this.props.content.hideheader ? 'border-0' : ' ')}>
              {!this.props.content.hideheader &&
                <div className={"card-header d-flex align-items-center pointer " + (this.props.content.panelheadercolor) + ' ' + + (this.props.content.panelheaderbg)} onClick={() => { this.setState({ showheader: !this.state.showheader }) }}>
                  <div className="pr-2 mb-0">
                    <span className="d-flex align-items-center">
                      <span>{this.state.HeaderTitle}</span>
                    </span>
                  </div>
                  <div className="ml-auto">
                    <i className={"fa fa-angle-" + (this.state.showheader ? 'down' : 'up')} aria-hidden="true"></i>
                  </div>
                </div>
              }
              <div className={"card-body " + this.props.content.panelBodyClass} hidden={!this.state.showheader}>
                <DynamicForm key={this.props.formid ? this.props.formid : this.state.formUI.Id} uiSchema={this.state.formUI} action={this.props.access} />
              </div>
            </div>
            :
            <div style={{ backgroundColor: this.props.content.panelbg }} className={"card mb-2 " + (this.props.content.showshadow && 'shadow') + ' ' + (this.props.content.panelClass) + ' ' + (this.props.content.hideheader ? 'border-0' : ' ')}>
              <div className={"card-body " + this.props.content.panelBodyClass} hidden={!this.state.showheader}>
                <DynamicForm key={this.props.formid ? this.props.formid : this.state.formUI.Id} uiSchema={this.state.formUI} action={this.props.access} />
              </div>
            </div>

        );
      } else if (!isApiCalling && this.state.formUI && token && !this.props.landingPage) {
        return (
          <DynamicForm key={this.props.formid ? this.props.formid : this.state.formUI.Id} uiSchema={this.state.formUI} action={this.props.access} />
        );
      } else {
        return null
      }
  }
}

DynamicformInit.propTypes = {
  formid: PropTypes.string,
  dataid: PropTypes.string,
  access: PropTypes.string,
  pageparams: PropTypes.object,
  formui: PropTypes.object,
  datamodel: PropTypes.object
};

export default connect(
  mapStateToProps, bindAction
)(DynamicformInit);